import React from "react";
import {Badge, ButtonBase, Tooltip, Typography} from "@mui/material";
import {alpha} from "@mui/material/styles";
import {grey} from "@mui/material/colors";
import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import {WORKSPACE_THEME} from "../../elevationTool/menubar/MenuBar";
import {ElevationCellFocus} from "./ElevationSidebarContext";
import {sidebarTabLabel} from "./useSidebarElevationApp";

// the collapsed sidebar: a strip on the right that re-opens it. While an elevation cell is
// focused it shows which one, so the user knows a preview is ready.
export function ElevationSidebarStrip(props: {
    focus: ElevationCellFocus | null;
    onOpen(): void;
}) {
    const focus = props.focus;
    const color = !focus ? grey["600"] : focus.type === "elevation" ? WORKSPACE_THEME[focus.kind] : grey["800"];
    const label = !focus ? "" : focus.type === "elevation" ? sidebarTabLabel(focus.tab) : focus.cell;
    const title = focus
        ? `Show the ${label.toLowerCase()} of ${focus.openingName || "opening " + focus.openingId}`
        : "Show the preview";

    return (
        <Tooltip title={title} placement="left">
            <ButtonBase onClick={props.onOpen} sx={{
                width: 28,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 1.5,
                pt: 1,
                borderLeft: "1px solid " + grey["300"],
                bgcolor: focus ? alpha(color, 0.08) : grey["50"],
                "&:hover": {bgcolor: focus ? alpha(color, 0.16) : grey["100"]},
            }}>
                <Badge variant="dot" invisible={!focus} sx={{"& .MuiBadge-badge": {bgcolor: color}}}>
                    <KeyboardDoubleArrowLeft sx={{fontSize: 18, color}} />
                </Badge>
                {focus && (
                    <Typography sx={{
                        writingMode: "vertical-rl",
                        fontSize: 11,
                        fontWeight: 600,
                        color,
                        whiteSpace: "nowrap",
                        lineHeight: 1,
                    }}>
                        {label} · {focus.openingName || focus.openingId}
                    </Typography>
                )}
            </ButtonBase>
        </Tooltip>
    );
}
